import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';
import type { OverviewCategory } from 'shared/src/api';

export const useLogClickHeadlineMore = () => {
  return useCallback((category: OverviewCategory) => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_HEADLINE_SMALL_ONE_LINE_MORE',
      analytics: {
        ...category.logging.analytics,
        SCREEN: 'OVERVIEW',
      },
    });
  }, []);
};
